import { render, staticRenderFns } from "./newflows.vue?vue&type=template&id=68ebd0f5&scoped=true"
import script from "./newflows.vue?vue&type=script&lang=js"
export * from "./newflows.vue?vue&type=script&lang=js"
import style0 from "./newflows.scss?vue&type=style&index=0&id=68ebd0f5&prod&lang=scss&scoped=true&external"
import style1 from "./newflows.vue?vue&type=style&index=1&id=68ebd0f5&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "68ebd0f5",
  null
  
)

export default component.exports